 import React, { FunctionComponent, } from 'react';
import {
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import { AppDispatch, RootState } from '../../store/store';
import { useTranslation, Trans, } from 'react-i18next';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import { useDispatch, useSelector } from 'react-redux';
import AppLayout from '../../layouts/AppLayout/AppLayout';
import { LoadingButton } from '@mui/lab';
import { Container } from '@mui/system';
import ErrorMessage from '../../components/ErrorMessage/ErrorMessage';

import './CustomSSOError.css';
import useTitle from '../../helpers/use-title';

const CustomSSOError: FunctionComponent = () => {

  const { t } = useTranslation( [ 'verifyError' ] );

  const dispatch = useDispatch<AppDispatch>();
  useTitle( t( 'an-error-occurred' ) );

  return (
    <AppLayout title={ t( 'your-account' ) }>
      <div className="page page-email-migration">
        <Container>
          <Card sx={ { mt: 4 } }>
            <CardContent>
              <ErrorMessage header={ t( 'an-error-occurred' ) }>
                <Trans t={ t } i18nKey="please-start-the-process-again-later"><p></p></Trans>
              </ErrorMessage>
            </CardContent>
          </Card>
        </Container>
      </div>
    </AppLayout>
  );
}

export default CustomSSOError;
